import React from 'react';
import { whatsappContact } from 'v3/components/ControlTower/TravelResources/contract';
import IdentityLink from './IdentityLink';

/** Coluna Telefone Motorista (5672): o número do cadastro abre a conversa no WhatsApp. */
export default function driverPhoneColumn(width = 150) {
  return {
    key: 'driverPhone',
    label: 'Telefone Motorista',
    width,
    value: (row) => whatsappContact(row.driver?.phone).display || 'Não informado',
    render: (row, value) => {
      const { href } = whatsappContact(row.driver?.phone);
      return href ? (
        <IdentityLink
          to={href}
          title={`Conversar no WhatsApp com ${row.driver?.name || 'o motorista'}`}
          aria-label={`Abrir WhatsApp de ${row.driver?.name || 'motorista'}: ${value}`}
        >
          {value}
        </IdentityLink>
      ) : (
        value
      );
    },
  };
}
